import { axiosBaseQuery, createAxiosInstance } from '@client';
import { getEnvironmentVariables } from '@common';
import { createApi } from '@reduxjs/toolkit/query/react';

const { API_URL, VESON_EXPORT_API_URL } = getEnvironmentVariables();

const vesonExportAxiosInstance = createAxiosInstance({
  baseURLParam: VESON_EXPORT_API_URL ?? `${API_URL}/veson-export`
});

export interface ExportDetailsDto {
  exportType: string;
  reference: string;
}

export const vesonExportApi = createApi({
  reducerPath: 'veson-export-api',
  baseQuery: axiosBaseQuery({
    baseUrl: '/api/veson',
    customAxiosInstance: vesonExportAxiosInstance
  }),
  endpoints: (build) => ({
    getReferenceForEvaluation: build.query<
      ExportDetailsDto,
      { evaluationId: number }
    >({
      query: ({ evaluationId }) => ({
        url: `/reference/evaluation/${evaluationId}`,
        method: 'GET'
      })
    })
  })
});

export const { useGetReferenceForEvaluationQuery } = vesonExportApi;
